import Gallery from "../Page/Gallery"
import Logo from "../App/Logo"


export default function Landing( props ) {
	// front.webp  yacht-2.webp

	const zoomedRowId=false
	const setZoomedRowId = id => {}

	const commonProps = { zoomedRowId, setZoomedRowId }

	return <>
		<div style={{ position:'relative' }} >

			{/*
		    <img 
		      className="cover" 
		      src={ process.env.PUBLIC_URL + '/img/front.webp' }
		    />
			*/}
			<Gallery 
				style={{ 
					borderRadius:0, height:'100vh', aspect:null,
					backgroundPositionX:'center', 
				}} 
				{ ...props } { ...commonProps } 
			/> 

		    <div style={{ 
		    	position:'absolute', left:0, top:0, width:'100%', height:'100%',
		    	background:'linear-gradient(#00000044,#00000066,#00000022)', 
	    	}} />
		    <div className="landing">
		    	<Logo />
		    </div>
		</div>
	</>
}

/*
export default function Landing( props ) {
	// front.webp  yacht-2.webp
	return <>
		<div style={{ position:'relative' }} >
		    <img 
		      className="cover" 
		      src={ process.env.PUBLIC_URL + '/img/front.webp' }
		    />
		    <div style={{ 
		    	position:'absolute', left:0, top:0, width:'100%', height:'100%',
		    	background:'linear-gradient(#00000044,#00000066,#00000022)', 
	    	}} />
		    <div className="landing">
		    	<Logo />
		    </div>
		</div>
	</>
}
*/